import styled from 'styled-components';

export const StyledSubCardActivityQuiz = styled.div`
  display: flex;

  &.scorm-no-quiz,
  &.scorm-no-info {
    flex-direction: column;
    justify-content: center;

    .statistics-heading {
      height: 24px;
    }
  }

  &.quiz,
  &.scorm-with-quiz {
    align-items: center;
    column-gap: 15px;
    justify-content: space-between;
    width: 100%;
    padding-right: 7px;

    .statistics-heading {
      height: 24px;
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;
